/**
 * All GA4 dataLayer variables. Each sendGAEvent must set every key so leftover
 * values from a previous event (e.g. news_click) do not pollute GTM.
 */
const GA4_DATALAYER_VARIABLES = [
  'article_language',
  'article_tags',
  'article_paywall',
  'event_value',
  'news_category1',
  'news_category2',
  'news_category3',
  'news_media',
  'news_url',
  'publish_date',
  'ui_element',
  'ab_test_variant',
  'login_status',
  'media_group',
]

/**
 * Set any missing GA4 keys to undefined so GTM does not reuse prior event values.
 * @param {object} eventDataLayer
 * @returns {object}
 */
export function withClearedGa4Variables(eventDataLayer) {
  GA4_DATALAYER_VARIABLES.forEach(variableName => {
    if (eventDataLayer[variableName] == null) {
      eventDataLayer[variableName] = undefined
    }
  })
  return eventDataLayer
}
